import { register, CloudObject, defineProperty, defineRelation, Direction } from 'olympe';
import System from "./System";

/**
 * @extends {CloudObject}
 */
export default class Version extends CloudObject {
    
    /**
     * @return {string}
     */
    getId() {
        return this.get(Version.idProp);
    }

    /**
     * @return {Date}
     */
    getCreationDate() {
        return this.get(Version.creationDateProp);
    }

    /**
     * @return {Date}
     */
    getLastModified() {
        return this.get(Version.lastModifiedProp);
    }

    /**
     * @return {boolean}
     */
    getDraft() {
        return this.get(Version.draftProp);
    }
}

// Hardcoded tags
register('01880fce5e97052d731d', Version);
Version.idProp = defineProperty('01880fcf2b0eafea4285');
Version.creationDateProp = defineProperty('01880fcf4eae4071b26f');
Version.lastModifiedProp = defineProperty('01880fcf66a647b29078');
Version.draftProp = defineProperty('01880fcfd65718284607');
Version.systemRel = defineRelation('01880fd120ea5d1eca19', Version, System);
Version.inverse_inspectionModuleversionsRel = defineRelation('01880fd00af70e9132f4', Direction.ORIGIN);